module.exports = __webpack_public_path__ + "assets/img/ZT8213-M.e0503199.png";